import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';

const HeadbandVamx = styled.p`
  width: 100%;
  background-color: ${select('blueDark')};
  color: ${select('white')};
  text-align: center;
  top: 69.5px;
  font-family: 'Hind';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 40px;
`;
const Link = styled.a`
  text-decoration: underline;
  font-weight: 600;
  color: ${select('white')};
`;

export { HeadbandVamx, Link };
